import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=be6b7bae&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=be6b7bae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6b7bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6b7bae')) {
      api.createRecord('be6b7bae', component.options)
    } else {
      api.reload('be6b7bae', component.options)
    }
    module.hot.accept("./ScrollPane.vue?vue&type=template&id=be6b7bae&scoped=true", function () {
      api.rerender('be6b7bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/TagsView/ScrollPane.vue"
export default component.exports